export default ['api', function (api) {
    return {
        find: (basketCode) => {
            return api.get(`/api/${api.property()}/basket/suggestions/${basketCode}`).
                then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/checkout/services/suggestions.api.service.js